/** Prototype defaults. Environment variables may override the server-side ones; see .env.example. */
export const LIMITS = {
  /** Session-wide cap on active players (role `player`). Modules narrow this through their manifest. */
  MAX_PLAYERS: 6,
  MIN_PLAYERS: 2,
  /** Read-only display screens per session. */
  MAX_SPECTATORS: 1,
  /** How long a disconnected participant keeps their slot before the host may release it, or the lobby releases it automatically. */
  DEFAULT_DISCONNECT_GRACE_MS: 120_000,
  /** Sessions idle for longer are purged by the retention sweep. */
  DEFAULT_SESSION_TTL_HOURS: 24,
  /** Accepted action outcomes remembered per session for idempotent retries (count and age bounds). Rejections are never cached. */
  ACTION_OUTCOME_MEMORY: 500,
  ACTION_OUTCOME_TTL_MS: 10 * 60_000,
  /** Per-connection action rate limit (token bucket). */
  ACTION_BURST: 20,
  ACTION_REFILL_PER_SECOND: 10,
  /** Maximum inbound WebSocket frame size in bytes. */
  MAX_FRAME_BYTES: 64 * 1024,
  /** Lobby emote rate limit: tokens per participant, refilled at EMOTE_REFILL_PER_SECOND. */
  EMOTE_BURST: 3,
  EMOTE_REFILL_PER_SECOND: 1,
  /** Short-code resolution attempts per client address per minute. */
  SHORT_CODE_ATTEMPTS_PER_MINUTE: 10,
  /** Join and presenter-creation attempts per client address per minute. */
  JOIN_ATTEMPTS_PER_MINUTE: 30,
  /** Session creations per client address per minute. */
  SESSION_CREATES_PER_MINUTE: 20,
  /** Display-name length. */
  DISPLAY_NAME_MAX: 32,
  /** Module deadline bounds: a suggested default turn length and the hard maximum for any single deadline. */
  DEFAULT_TURN_MS: 30_000,
  MAX_DEADLINE_MS: 30 * 60_000,
  /** Minimum remaining time re-armed for a deadline after a server restart recovery. */
  RECOVERY_MIN_REMAINING_MS: 5_000,
  /** WebSocket heartbeat. */
  HEARTBEAT_INTERVAL_MS: 15_000,
  HEARTBEAT_TIMEOUT_MS: 35_000,
} as const;

export const PROTOCOL_VERSION = 1;
/** Short join code format: 6 characters from an alphabet without 0/O/1/I. */
export const SHORT_CODE_REGEX = /^[ABCDEFGHJKLMNPQRSTUVWXYZ23456789]{6}$/;
